<template>
    <div>
    <h2> Account Recovery </h2>
    <!-- <div class='loader'>Loading<span class='loader__dot'>.</span><span class='loader__dot'>.</span><span class='loader__dot'>.</span></div> -->
    <div v-if="inValidEmail === null">
        <div :ref="'showEmailInput'">
        <input class="input-text" type="text" id="resetEmail" :ref="'resetEmail'" @blur="checkEmail" placeholder="email or username" />
        <div class="error-notify" :ref="'resetEmailInfo'"></div>
        </div>
        <div :ref="'initialInput'">or</div>
        <div :ref="'showPhoneInput'">
         <input class="input-text" type="text" id="resetPhone" :ref="'resetPhone'" @blur="checkPhone" placeholder="phonenumber" />
        <div class="error-notify" :ref="'resetPhoneInfo'"></div>
        </div>
        <div :ref="'loader'" class='loader'>Loading<span class='loader__dot'>.</span><span class='loader__dot'>.</span><span class='loader__dot'>.</span></div>
    </div>

    <div v-if="isEmailCheck === false | isPhoneCheck === false">
        <span class="notifyShortCode">
            A short code has been sent to {{recoveryMethod}}
            <br>
            <input type="text" :ref="'shortCode'" placeholder="DW-" @blur="setScode" />
            <div class="error-notify" :ref="'scodeMessage'"></div>
            <br>
            <button :ref="'submitScode'" @click.prevent="submitScode">Submit</button>
            <button :ref="'clearScode'" @click.prevent="clearScode">Clear</button>
        </span>
        <div v-if="isRecoveryReady === true">
            <input type="password" :ref="'pwd1'" placeholder="enter your new password" @input="complexity"/>
            <div :ref="'credRequirements'"><span :ref="'lc'"><small>a-z,</small></span><span :ref="'uc'"><small> A-Z,</small></span><span :ref="'num'"><small> 0-9,</small></span><span :ref="'sym'"><small> Symbols,</small></span><span :ref="'len'"><small> Min. Length: 8</small></span>
        </div>
            <input type="password" :ref="'pwd2'" placeholder="confirm your new password" @blur="matched" />
            <div class="error-notify" :ref="'pwd2MatchResults'"></div>
            <button :disabled="isMatching" @click.prevent="saveCred">Save New Credential</button>
            <button @click.prevent="clearCred">Clear</button>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
import { AsYouType } from 'libphonenumber-js';
var HOST="";
// const loder = "<div class='loader'>Loading<span class='loader__dot'>.</span><span class='loader__dot'>.</span><span class='loader__dot'>.</span></div>"
export default {
    name: 'reset',
    data() {
        return {
            emailFound: null,
            phoneFound: null,
            recoveryMethod: null,
            scode: null,
            recoveryNarrative: null,
            temp: null,
            recoveryReady: null,
            matching: null
        }
    },
    mounted() {
        HOST = this.getHost;
    },
    methods: {
    ...mapActions(['updateUserStatus', 'showResetForm', 'updateVisitorStatus']),
        async checkEmail(){
            console.log('checkEmail');
            const expression = /\S+@\S+/;
            let testAddress = expression.test(String(event.target.value).toLowerCase());
            if(testAddress){
                let test = {
                    method: 'email',
                    value: this.$refs["resetEmail"].value
                }
                let spinning = true;
                    if(spinning){
                    this.$refs["showPhoneInput"].hidden = true;
                    this.$refs["initialInput"].innerText = "";
                    this.$refs["loader"].style = 'visibility: visible; color:green';
                }
                    //test db for email account exists and resolve async
                let verification = await axios.post(`${HOST}/account`, {test});
                console.log("test", verification);

                if(verification.data.message === "account found"){
                    spinning = false
                    this.$refs["resetEmailInfo"].style = "color:red";
                    this.$refs["resetEmailInfo"].innerText = ""
                    this.$refs["loader"].style = 'visibility: hidden';
                    this.emailFound = true;
                    this.recoveryMethod = test.value;
                    this.resetId = verification.data.messageID;
                    this.$nextTick(() => this.inValidEmail);
                }
                this.$refs["resetEmailInfo"].innerText = "";
            } else {
                // spinning = false
                this.$refs["resetEmailInfo"].style = "color:red";
                this.$refs["resetEmailInfo"].innerText = "check your email address";
            }
        },
        async checkPhone(event){
            let testAddress = null;
            console.log("checkPhone");
            if(event.target.value.length === 10){
                testAddress = true;
            } else {
                testAddress = false;
            }

            if(testAddress){
                let asyoutype = new AsYouType("US");
                asyoutype.input(this.$refs["resetPhone"].value);
                let entered = asyoutype.getNumber().number;
                    console.log(entered);
                let test = {
                    method: 'phone',
                    value: entered
                }
                let spinning = true;
                    if(spinning){
                    this.$refs["showEmailInput"].hidden = true;
                    this.$refs["initialInput"].innerText = "";
                    this.$refs["loader"].style = 'visibility: visible; color:green';
                }

                    //test db for email account exists and resolve async
                let verification = await axios.post(`${HOST}/account`, {test});
                console.log("test", verification.data);
                if(verification.data.message === "account found"){
                    spinning = false
                    this.$refs["resetPhoneInfo"].style = "color:red";
                    this.$refs["resetPhoneInfo"].innerText = ""
                    this.$refs["loader"].style = 'visibility: hidden';
                    this.phoneFound = true;
                    this.recoveryMethod = test.value;
                    this.resetId = verification.data.messageID;
                    this.$nextTick(() => this.inValidPhone);
                }
            } else {
                // spinning = false
                this.$refs["resetPhoneInfo"].style = "color:red";
                this.$refs["resetPhoneInfo"].innerText = "check your phone number";
            }
        },
        async submitScode(){
            console.log('submitScode');
            let reset = {
                scode: this.$refs["shortCode"].value,
                resetID: this.resetId
            }
            const resolver = await axios.post(`${HOST}/checkCode`,{reset});
            console.log(resolver.data);
            if(resolver.data.message === "yay"){
                this.temp = resolver.data.userid;
                this.recoveryReady = true;
                this.$nextTick(() => this.isRecoveryReady);
                this.$refs["scodeMessage"].innerText = "";
            } else {
                this.$refs["scodeMessage"].innerText = "try again";
            }
        },
        clearScode(){
            this.$refs["shortCode"].value="";
        },
        clearCred(){
            this.$refs["pwd1"].value = "";
            this.$refs["pwd2"].value = "";
        },
        async saveCred(){
            let cred = {
                userid: this.temp,
                cred: this.$refs["pwd1"].value
            }
            const savedCreds = await axios.post(`${HOST}/saveCode`,{cred});
            if(savedCreds.data.message === "yay"){
                let d = new Date();
                let expires = d.setTime(d.getTime() + (1*24*60*60*1000));
                this.updateUserStatus("notauth");
                this.$cookies.set("authStatus", "notauth", "expires="+expires.toString());
                this.$cookies.set("dw_id", this.temp, "expires="+expires.toString())
                this.updateVisitorStatus("existing");
                this.$nextTick(() => this.getUserStatus);
                this.$nextTick(() => this.getVisitorStatus);
                this.showResetForm(false);
            }
        },
        setScode(event){
            let test = event.target.value.slice(0,3);
                console.log(test);
                if(test === "DW-"){
                    return event.target.value
                } else {

                event.target.value = "DW-"+event.target.value;
                }
        },
        matched(){
             if(this.$refs["pwd1"].value === this.$refs["pwd2"].value){
                    this.$refs["pwd2MatchResults"].innerText = "Good to Go!";
                    this.$refs["pwd2MatchResults"].style = "color:green";
                    this.matching = true;
                    this.$nextTick(() => this.isMatching);
                } else {
                    this.$refs["pwd2MatchResults"].innerText = "Passwords don't match";
                    this.$refs["pwd2MatchResults"].style = "color:red";
                }
        },
        complexity(event){
            let credtest = [];
            credtest.push(event.target.value);

            let hasUpperCase = /[A-Z]/.test(credtest);
            let hasLowerCase = /[a-z]/.test(credtest);
            let hasNumbers = /\d/.test(credtest);
            let hasSymbols = /\W/.test(credtest);

            if(hasLowerCase){
                this.$refs["lc"].style="color:green";
            } else {
                this.$refs["lc"].style="color:red";
            }
            if(hasUpperCase){
                this.$refs["uc"].style="color:green";
            } else {
                this.$refs["uc"].style="color:red";
            }
            if(hasNumbers){
                this.$refs["num"].style="color:green";
            } else {
                this.$refs["num"].style="color:red";
            }
            if(hasSymbols){
                this.$refs["sym"].style="color:green";
            } else {
                this.$refs["sym"].style="color:red";
            }
            if(event.target.value.length >= 8){
                this.$refs["len"].style="color:green";
                this.$refs["len"].innerText = `Length: ${event.target.value.length}`;
            } else {
                this.$refs["len"].innerText = `Length: ${event.target.value.length}`;
                this.$refs["len"].style="color:red";
            }
        }
    },
    computed: {
        ...mapGetters(['getVisitorStatus', 'getUserStatus', 'getHost']),
        inValidEmail(){
            return this.emailFound;
        },
        inValidPhone(){
            return this.phoneFound;
        },
        isEmailCheck(){
            if(this.emailFound){
                return false;
            } else {
                return true;
            }
        },
        isPhoneCheck(){
            if(this.phoneFound){
                return false;
            } else {
                return true;
            }
        },
        isRecoveryReady(){
            if(this.recoveryReady){
                return true;
            } else {
                return false;
            }
        },
        isMatching(){
            if(this.matching){
                return false;
            } else {
                return true;
            }
        }
    },

}
</script>

<style scoped>
.input-text {
    border: solid 1px darkgrey;
    height: 20px;
    width: 150px;
    margin: 5px;
    padding: 2px;
}
.error-notify {
    color: red;
}
.loader{
    visibility: hidden;
}

 @keyframes blink {50% { color: transparent }}
.loader__dot { animation: 1s blink infinite }
.loader__dot:nth-child(2) { animation-delay: 250ms }
.loader__dot:nth-child(3) { animation-delay: 500ms }

</style>